import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 52, 500)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 32, 500)}
    }
`;

export const CustomText = styled(Text)`
    ${FONT("notoSerif", 16, 500)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("notoSerif", 14, 500)}
    }
`;
